//Check value is greater than or equal compare value
//PASS: value is valid, returns true
//FAIL: value is invalid, returns false
export const CheckValueGreaterThanEqual = ({ value, compareValue }) =>
  value >= compareValue;
